
export enum EUnitStatus {
  Unknown,
  Ok,
  Warning,
  Error,
}

export interface IVariable {
  unitId: string;
  attribute: string;
  value?: number
}